<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div id="contentToCopy" class="card pulish-card-report-main">
  <div class="logo-header bg-white">
    <!-- <img src="../../../assets/images/finreg_logo_footer.png" /> -->
    <img [src]="imageSrc" type="image/png">
  </div>
  <div class="card-body">
    <div style="margin-bottom: 20px;">
      <div class="d-flex align-items-center justify-content-between">
        <div class="fg-light-blue" style="font-size:22px; font-weight: 500;text-transform: uppercase;">
          {{publishReport.title}}
        </div>
        <div>
          <button pButton icon="pi pi-copy" class="btn-blue pdf-btn" (click)="copyToClipboard()" matTooltip="Copy to Clipboard"></button>
          <button pButton icon="fa fa-file-pdf-o" class="btn-blue pdf-btn" [loading]="loading"
            (click)="exportAsPDF()" matTooltip="Download"></button>
        </div>
      </div>
      <div class="bg-light-blue" style="font-size:18px; font-weight: 500;padding: 10px;margin-top: 10px;">Regulatory
        Publications brought to you by FinregE</div>
      <p class="fg-light-blue" style="font-weight: 500;margin-top: 10px;">{{publishReport.reportDate |
        date:'dd-MM-yyyy'}}</p>
    </div>
    <div *ngFor="let report of publishReport.reportData" style="margin-bottom: 20px;">
      <div class="fg-light-blue" style="font-size:20px; font-weight: 500;text-transform: uppercase;">{{report.header}}
      </div>
      <hr class="primary-line" />
      <div class="card publish-report-card" *ngFor="let regulation of report.regulations"
        style="margin-top: 10px;font-size:16px;">
        <div class="card-body">
          <div>
            <span style="font-weight: 600">Publication Date : </span> {{regulation.date | date:'yyyy-MM-dd'}} |
            <span style="font-weight: 600">Regulator : </span> {{regulation.regulator}}
            <span style="font-weight: 600" *ngIf="publishReport.isId"> | FinregE Id : </span>
            <span class="fg-light-blue" *ngIf="publishReport.isId">
              <a href="/change-detail?id={{regulation.id}}&detailType=1&libId={{regulation.libraryId}}"
                target="_blank">{{regulation.id}}</a>
            </span>
          </div>
          <div style="margin-top: 10px;">
            <div style="font-weight: 600">Title</div>
            <div *ngIf="!regulation.hyperlink" style="margin-top:10px; line-height: 1.5;">{{regulation.title}}</div>
            <div *ngIf="regulation.hyperlink" style="margin-top:10px; line-height: 1.5;">
              <a href="{{regulation.hyperlink}}" target="_blank">{{regulation.title}}</a>
            </div>
          </div>
          <div style="margin-top: 10px;" *ngIf="publishReport.isDescription">
            <div style="font-weight: 600">Description</div>
            <p style="margin-top:10px; line-height: 1.8;text-align:justify;font-size:15px;"
              [innerHtml]="regulation.description"></p>
          </div>

          <div class="d-flex card_footer justify-content-between">
            <div style="margin-top: 10px;">
              <div style="font-weight: 600">
                <span *ngIf="publishReport.isStatus">Status</span>
                <span *ngIf="publishReport.isStatus && publishReport.isActionedBy"> / </span>
                <span *ngIf="publishReport.isActionedBy">Actioned By</span>
              </div>
              <div *ngIf="regulation.closedRegulation && regulation.closedRegulation.length > 0">
                <ng-container *ngFor="let clReg of regulation.closedRegulation">
                  <div style="margin-bottom: 2px;">
                    <span *ngIf="publishReport.isStatus">{{clReg.jurisdiction}} | {{clReg.status}}</span>
                    <span *ngIf="publishReport.isActionedBy"> | {{clReg.actionedBy}}</span>
                  </div>
                </ng-container>
              </div>
              <div *ngIf="regulation.closedImpactAssessment && regulation.closedImpactAssessment.length > 0">
                <ng-container *ngFor="let clReg of regulation.closedImpactAssessment">
                  <div style="margin-top: 10px;margin-bottom: 2px;">
                    <span *ngIf="publishReport.isStatus">{{clReg.jurisdiction}} | {{clReg.status}}</span>
                    <span *ngIf="publishReport.isActionedBy"> | {{clReg.actionedBy}}</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div style="margin-top: 20px;">
              <div style="font-weight: 600">
                <span *ngIf="publishReport.isEffectiveDate">Effective Date</span>
                <span *ngIf="publishReport.isEffectiveDate && publishReport.isAssessor"> / </span>
                <span *ngIf="publishReport.isAssessor">Assessor</span>
              </div>
              <div *ngIf="regulation.closedImpactAssessment && regulation.closedImpactAssessment.length > 0">
                <ng-container *ngFor="let clReg of regulation.closedImpactAssessment">
                  <div style="margin-top: 10px;margin-bottom: 2px;">
                    <span *ngIf="publishReport.isEffectiveDate">{{clReg.effectiveDate | date:'yyyy-MM-dd'}}</span>
                    <span *ngIf="publishReport.isAssessor"> | {{clReg.assessor}}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <hr/>
        </div>
        <!-- <hr
          style="border-color: #5a9bd5 !important;border-top: 2px solid rgba(0,0,0,.1);margin-top:20px;margin-bottom:20px;" /> -->
      </div>
    </div>
  </div>
</div>

<!--Download html Template-->
<div id="pdfContent" #pdfContent class="card" style="display: none;">
  <div class="logo-header bg-white">
    <!-- <img src="../../../assets/images/finreg_logo_footer.png" /> -->
    <img [src]="imageSrc" type="image/png">
  </div>
  <div class="card-body" 
    style="page-break-before:always;font-family: 'Roboto', sans-serif;">
    <div style="margin-bottom: 20px;font-family: 'Roboto', sans-serif;">
      <div style="font-size:22px; font-weight: 500;text-transform: uppercase; color: #5a9bd5">
        {{publishReport.title}}</div>
      <div style="font-size:18px; font-weight: 500;padding: 10px;margin-top: 10px;
       background-color: #5a9bd5;color: #ffffff">Regulatory
        Publications brought to you by FinregE</div>
      <p style="font-weight: 500;margin-top: 10px; color: #5a9bd5">{{publishReport.reportDate | date:'dd-MM-yyyy'}}</p>
    </div>
    <div *ngFor="let report of publishReport.reportData" style="margin-bottom: 20px;font-family: 'Roboto', sans-serif;">
      <div style="font-size:20px; font-weight: 500;text-transform: uppercase; color: #5a9bd5">{{report.header}}
      </div>
      <hr style="border-color: #5a9bd5 !important;border-top: 3px solid rgba(0,0,0,.1);" />
      <div *ngFor="let regulation of report.regulations" style="margin-top: 10px;font-size:16px;
      -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
      border: none !important;
      -webkit-animation-duration: 10s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      -webkit-animation-name: fadeIn;
      animation-name: fadeIn;
    ">
        <div style="flex: 1 1 auto; min-height: 1px; padding: 1.25rem;">
          <div>
            <span style="font-weight: 600">Publication Date : </span> {{regulation.date | date:'yyyy-MM-dd'}} |
            <span style="font-weight: 600">Regulator : </span> {{regulation.regulator}}
            <span style="font-weight: 600" *ngIf="publishReport.isId"> | FinregE Id : </span>
            <span style="color: #5a9bd5;" *ngIf="publishReport.isId">
              {{regulation.id}}
            </span>
          </div>
          <div style="margin-top: 10px;">
            <div style="font-weight: 600">Title</div>
            <div *ngIf="!regulation.hyperlink" style="margin-top:10px; line-height: 1.5;">{{regulation.title}}</div>
            <div *ngIf="regulation.hyperlink" style="margin-top:10px; line-height: 1.5;">
              {{regulation.title}}
            </div>
          </div>
          <div style="margin-top: 10px;" *ngIf="publishReport.isDescription">
            <div style="font-weight: 600">Description</div>
            <p style="margin-top:10px; line-height: 1.8;text-align:justify;font-size:15px;"
              [innerHtml]="regulation.description"></p>
          </div>

          <div style="margin-top: 10px; width: 100%; display: inline-block;">
            <div style="margin-top: 10px; width: 50%; display: inline-block;">
              <div style="font-weight: 600;">
                <span *ngIf="publishReport.isStatus">Status</span>
                <span *ngIf="publishReport.isStatus && publishReport.isActionedBy"> / </span>
                <span *ngIf="publishReport.isActionedBy">Actioned By</span>
              </div>
              <div *ngIf="regulation.closedRegulation && regulation.closedRegulation.length > 0">
                <ng-container *ngFor="let clReg of regulation.closedRegulation">
                  <div style="margin-bottom: 2px;">
                    <span *ngIf="publishReport.isStatus">{{clReg.jurisdiction}} | {{clReg.status}}</span>
                    <span *ngIf="publishReport.isActionedBy"> | {{clReg.actionedBy}}</span>
                  </div>
                </ng-container>
              </div>
              <div *ngIf="regulation.closedImpactAssessment && regulation.closedImpactAssessment.length > 0">
                <ng-container *ngFor="let clReg of regulation.closedImpactAssessment">
                  <div style="margin-top: 10px;margin-bottom: 2px;">
                    <span *ngIf="publishReport.isStatus">{{clReg.jurisdiction}} | {{clReg.status}}</span>
                    <span *ngIf="publishReport.isActionedBy"> | {{clReg.actionedBy}}</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div style="margin-top: 20px; width: 50%; display: inline-block; text-align: end;">
              <div style="font-weight: 600">
                <span *ngIf="publishReport.isEffectiveDate">Effective Date</span>
                <span *ngIf="publishReport.isEffectiveDate && publishReport.isAssessor"> / </span>
                <span *ngIf="publishReport.isAssessor">Assessor</span>
              </div>
              <div *ngIf="regulation.closedImpactAssessment && regulation.closedImpactAssessment.length > 0">
                <ng-container *ngFor="let clReg of regulation.closedImpactAssessment">
                  <div style="margin-top: 10px;margin-bottom: 2px;">
                    <span *ngIf="publishReport.isEffectiveDate">{{clReg.effectiveDate | date:'yyyy-MM-dd'}}</span>
                    <span *ngIf="publishReport.isAssessor"> | {{clReg.assessor}}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <hr style="border-color: #5a9bd5 !important;border-top: 2px solid rgba(0,0,0,.1);margin-top:20px;" />
      </div>
    </div>
  </div>
</div>

<!-- <div id="contentToCopy"></div> -->